class Headline {
  constructor(id, createdAt, updatedAt, image, link, title, description) {
    this.id = id;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.image = image;
    this.link = link;
    this.title = title;
    this.description = description;
  }
}

export default Headline;
